/* ============
 * Vue Router
 * ============
 *
 * The official Router for Vue.js. It deeply integrates with Vue.js core
 * to make building Single Page Applications with Vue.js a breeze.
 *
 * http://router.vuejs.org/en/index.html
 */

import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from '@/app/routes'
import store from '@/app/store'
import * as localeMutations from '@/app/store/modules/locale/mutation-types'

Vue.use(VueRouter)

export const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.beforeEach((to, from, next) => {
  // handle application locale
  if (to.params.locale) {
    store.commit(`locale/${localeMutations.SET_LOCALE}`, to.params.locale)
  } else {
    store.commit(`locale/${localeMutations.SET_LOCALE}`, store.state.locale.default)
  }

  if (to.matched.some(m => m.meta.auth) && !store.getters['auth/authenticated']) {
    /*
     * If the user is not authenticated and visits
     * a page that requires authentication, redirect to the login page
     */
    next({
      name: 'login.index'
    })
  } else if (to.matched.some(m => m.meta.guest) && store.state.auth.authenticated) {
    /*
     * If the user is authenticated and visits
     * an guest page, redirect to the dashboard page
     */
    next({
      name: 'dashboard.index'
    })
  } else {
    next()
  }
})

Vue.router = router

export default {
  router
}



// WEBPACK FOOTER //
// ./src/app/plugins/vue-router.js